import React from "react";
import LoginForm from "./LoginForm/LoginForm";
import "./LoginPage.css";
import BjsImage from "../../../images/bjsLogoWhiteBG.png";
import { Carousel } from "antd";
import { Navigate } from "react-router-dom";

// Try 2: 

const LoginPage = () => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>
    <div className="main-container">
      <div className="login-field animate__animated">
        <div className="loginimages">
          <div className="login-orange"></div>
          <div className="login-darkblue"></div>
          <div className="login-blue"></div>
          <div className="login-green"></div>
          <div className="login-yellow"></div>
        </div>
        
        <div className="logo">
          <img src={BjsImage} alt="BJS image." width="200px"/>
        </div>
      
        <div className="text">
          <h2  style={{ marginBottom:"10px", fontSize: "1.5rem"}}>Welcome</h2>  
        </div>
        
        <div>
          <form className="input_n_btns">
            <LoginForm/>          
          </form>
        </div>
      </div>
          
      
       
    </div>  
  </>



}
export default LoginPage;